import CustomInput from 'src/components/general/Form'
import styled from 'styled-components'
import { useCallback } from 'react'

interface DefaultTokenThresholdEditProps {
  task: {
    id: string
    taskConfig: {
      defaultTokenThreshold: {
        id: string
        max: string
        min: string
        token: {
          id: string
          name: string
          decimals: string
          symbol: string
        }
      }
    }
  }
  handleInputChange: (taskId: string, field: string, value: string) => void
}

const DefaultTokenThresholdEdit: React.FC<DefaultTokenThresholdEditProps> = ({ task, handleInputChange }) => {
  const memoizedHandleInputChange = useCallback(
    (field: string, value: string) => handleInputChange(task.id, field, value),
    [task.id, handleInputChange]
  )

  return (
    <div>
      <div className="flex-group">
        <FlexColumn>
          <Flex>
            <CustomInput
              type="text"
              name="min"
              label="Min"
              value={task?.taskConfig?.defaultTokenThreshold?.min || ''}
              onChange={(e) => memoizedHandleInputChange('defaultTokenThreshold.min', e.target.value)}
            />
          </Flex>
          <Flex>
            <CustomInput
              type="text"
              name="max"
              label="Max"
              value={task?.taskConfig?.defaultTokenThreshold?.max || ''}
              onChange={(e) => memoizedHandleInputChange('defaultTokenThreshold.max', e.target.value)}
            />
          </Flex>
          <TokenRow>
            <TokenLabel>
              <strong>Address:</strong> {task?.taskConfig?.defaultTokenThreshold?.token?.id || 'N/A'}
            </TokenLabel>
          </TokenRow>
          <TokenRow>
            <TokenLabel>
              <strong>Symbol:</strong> {task?.taskConfig?.defaultTokenThreshold?.token?.symbol || 'N/A'}
            </TokenLabel>
            <TokenLabel>
              <strong>Name:</strong> {task?.taskConfig?.defaultTokenThreshold?.token?.name || 'N/A'}
            </TokenLabel>
            <TokenLabel>
              <strong>Decimals:</strong> {task?.taskConfig?.defaultTokenThreshold?.token?.decimals || 'N/A'}
            </TokenLabel>
          </TokenRow>
        </FlexColumn>
      </div>
    </div>
  )
}

export default DefaultTokenThresholdEdit

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
`

const TokenLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #a0a0a0;
  strong { color: #ededed; font-weight: 500; }
`

const TokenRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 8px;
  padding: 10px 12px;
  background: #111;
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 6px;
` 